<div [formGroup]="formGroup">
    <button [disabled]="!editor" mat-raised-button (click)="toggleHTMLCode($event)">{{ format }}</button>
    <quill-editor *ngIf="format === 'text'" 
        placeholder="הכנס טקסט כאן"
        [formControlName]="inputName"
        (onEditorCreated)="activateRTL($event)"
        dir="ltr">
    </quill-editor>
    <ngx-monaco-editor *ngIf="format === 'html'" [options]="editorOptions" 
        [formControlName]="htmlInputName" (onInit)="onEditorInit($event)">
    </ngx-monaco-editor>
</div>